import {Page} from "../../components/common";
import {Trans, useTranslation} from "react-i18next";
import {useClient} from "../../hooks";
import {useMutation} from "react-query";
import {useEffect} from "react";

export const ZidOAuth = () => {
  const { t } = useTranslation();
  const client = useClient();

  const { data: href, isLoading, mutate } = useMutation(() => client.get('zid/oauth/authorize_uri').get('data'));

  useEffect(mutate, [mutate]);

  if (isLoading) return null;

  return (
    <Page translate={false} title={t('Zid Connect')}>
      <a href={href} className="btn btn-primary" rel="noreferrer noopener">
        <Trans>
          Connect a Zid store to WP Connect
        </Trans>
      </a>
    </Page>
  )
}